<template>
  <div>
    <back-btn />
    <!-- Alert: No item found -->
    <b-alert
      variant="danger"
      :show="physicianData === undefined"
    >
      <h4 class="alert-heading">
        Erro ao buscar physician data
      </h4>
      <div class="alert-body">
        No physician found with this physician id. Check
        <b-link
          class="alert-link"
          :to="{ name: 'physicians-list'}"
        >
          Physician List
        </b-link>
        for other physicians.
      </div>
    </b-alert>

    <template v-if="physicianData">
      <!-- First Row -->
      <b-row class="match-height">
        <b-col
          cols="12"
          xl="6"
          lg="6"
          md="7"
        >
          <physician-view-physician-info-card :physician-data="physicianData" />
        </b-col>
        <b-col
          cols="12"
          md="5"
          xl="3"
          lg="4"
        >
          <physician-view-physician-address-card :physician-data="physicianData" />
        </b-col>
        <b-col
          cols="12"
          md="5"
          xl="3"
          lg="4"
        >
          <physician-view-companies-card :physician-data="physicianData" />
        </b-col>
        <b-col
          cols="12"
          xl="12"
          lg="12"
          md="12"
        >
          <physician-view-accounts-card :physician-data="physicianData" />
        </b-col>
      </b-row>

    </template>

  </div>
</template>

<script>
import store from '@/store'
import router from '@/router'
import { ref, onUnmounted } from '@vue/composition-api'
import {
  BRow, BCol, BAlert, BLink,
} from 'bootstrap-vue'
import BackBtn from '@core/components/navigation/BackBtn.vue'
import physicianStoreModule from '../physicianStoreModule'
import PhysicianViewPhysicianInfoCard from './PhysicianViewPhysicianInfoCard.vue'
import PhysicianViewPhysicianAddressCard from './PhysicianViewPhysicianAddressCard.vue'
import PhysicianViewAccountsCard from './PhysicianViewAccountsCard.vue'
import PhysicianViewCompaniesCard from './PhysicianViewCompaniesCard.vue'

export default {
  components: {
    BRow,
    BCol,
    BAlert,
    BLink,
    BackBtn,

    // Local Components
    PhysicianViewPhysicianInfoCard,
    PhysicianViewPhysicianAddressCard,
    PhysicianViewAccountsCard,
    PhysicianViewCompaniesCard,
  },
  setup() {
    const physicianData = ref(null)

    const USER_APP_STORE_MODULE_NAME = 'app-physician'

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, physicianStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    store.dispatch('app-physician/fetchPhysician', { id: router.currentRoute.params.id })
      .then(response => { physicianData.value = response.data.data })
      .catch(error => {
        if (error.response.status === 404) {
          physicianData.value = undefined
        }
      })

    return {
      physicianData,
    }
  },
}
</script>

<style>

</style>
